import { useState, useRef } from "react";
import {
  UPLOAD_IMAGE_API,
  UPDATE_PROPERTY_IMAGE,
  DELETE_IMAGE_API,
} from "../../api/apiPath";
import { hostName } from "../../config/config";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import http from "../../api/server";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Toaster from "./Toaster";
import Webcam from "react-webcam";

function UploadPropertyImage({
  propertyId,
  handleCancel,
  propertyName,
  inspectionRefnumber,
}) {
  const { clientNameParam } = useParams();
  const [capturedImages, setCapturedImages] = useState([]);
  const [savedImages, setSavedImages] = useState([]);
  const { userObj } = useSelector((state) => state.user);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [showCamera, setShowCamera] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const webcamRef = useRef(null);
  const fileRef = useRef(null);
  const [facingMode, setFacingMode] = useState("user");
  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  const videoConstraints = {
    width: 640,
    height: 480,
    facingMode: facingMode,
  };
  const switchCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };
  const closeCamera = () => {
    setShowCamera(false);
  };
  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      const newImages = [...capturedImages, imageSrc];
      updateImages(newImages);
      setShowCamera(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...capturedImages, reader.result];
        updateImages(newImages);
      };
      reader.readAsDataURL(file);
    }
  };
  const updateImages = async (newImages) => {
    setCapturedImages(newImages);
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages);
      newArr = [...newArr, uploadResult];
    } else {
      newArr = [];
    }
    console.log("", newArr);
    setSavedImages(newArr);
  };

  const base64ToFile = (base64String, filename) => {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    const extnsion = mime.split("/")[1];
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], `${filename}.${extnsion}`, { type: mime });
  };

  const uploadImageAPI = async (newImages) => {
    const latestImage = newImages[newImages.length - 1];
    const file = base64ToFile(latestImage, `Property_Image_${Date.now()}`);
    const formDataToUpload = new FormData();
    formDataToUpload.append("File", file);
    formDataToUpload.append("Client", "ABC"); // Use actual values from state/context if needed
    formDataToUpload.append("Property", { propertyName });
    formDataToUpload.append("InspectionDate", new Date().toISOString());
    try {
      const response = await fetch(hostName + UPLOAD_IMAGE_API, {
        method: "POST",
        body: formDataToUpload,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const dataResponse = await response?.json();
      return dataResponse?.result.blobUrl;
    } catch (error) {
      setError(error?.data);
      return {};
    }
  };

  // const gotoDashBoard = (propertyId) => {
  //     const pathTemplate = "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber";
  //         const params = {
  //           clientNameParam: clientNameParam,
  //           propertyMasterId: propertyId,
  //           inspectionRefnumber: inspectionRefnumber
  //         };

  //         const fullPath = generatePath(pathTemplate, params);
  //         navigate(fullPath);
  // };

  const gotoScanQRCode = (propertyId) => {
    const pathTemplate =
      "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";

    const params = {
      clientNameParam,
      propertyMasterId: propertyId,
      inspectionRefnumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const savePropertyImage = async () => {
    if (savedImages.length > 0) {
      setIsLoading(true);
      const saveData = {
        propertyMasterId: propertyId,
        propertyImage: savedImages.length > 0 ? savedImages[0] : "",
      };
      const jsonData = JSON.stringify(saveData);
      try {
        const response = await http.put(UPDATE_PROPERTY_IMAGE, jsonData);
        if (!response.status) {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
        if (response.status === 200) {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString:
              "The uploaded image has been saved for " + propertyName,
          });

          setTimeout(() => gotoScanQRCode(propertyId), 2000);
        } else {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in saving image, please try again",
          });
          setIsLoading(false);
          handleCancel();
        }
      } catch (error) {
        setError(error?.data);
      }
    }
  };
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const removeImage = (indexToRemove) => {
    const newImages = capturedImages.filter(
      (_, index) => index !== indexToRemove
    );
    deleteImages(newImages, indexToRemove);
    fileRef.current.value = "";
  };
  const deleteImages = (newImages, indexToRemove) => {
    setCapturedImages(newImages);
    let imageToDelete = savedImages[indexToRemove];
    const combined = savedImages.filter((_, index) => index !== indexToRemove);
    setSavedImages(combined);
    deleteImageAPI(imageToDelete);
  };
  const deleteImageAPI = async (imageToDelete) => {
    try {
      const response = await http.delete(DELETE_IMAGE_API + imageToDelete);
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      setError(error?.data);
    }
  };

  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );
  return (
    <div className="modal-overlay">
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />
      <div className="modal-content" style={{ height: "auto", width: "50%" }}>
        <span className="close" onClick={() => handleCancel()}>
          &times;
        </span>
        <h6 className="modal-header">
          Upload Property Image for {propertyName}
        </h6>{" "}
        {/* Modal Header */}
        <div className="modal-body" style={{ backgroundColor: "white" }}>
          <h5 style={{ textAlign: "justify" }}>Main Door Photo</h5>
          <div className="d-flex gap-3 pb-4 align-items-center pt-2">
            <input
              type="file"
              accept=".jpg, .jpeg, .png, .gif"
              onChange={handleFileChange}
              className="form-control"
              id="chooseFiles"
              disabled={capturedImages.length >= 1}
              ref={fileRef}
            />
            {!showCamera && (
              <div>
                <i
                  className="fa-solid fa-camera fa-xl mainCamera"
                  onClick={() => {
                    if (!(capturedImages.length >= 1)) {
                      setShowCamera(true);
                    }
                  }}
                  title="Open Camera"
                  style={{
                    cursor:
                      capturedImages.length >= 1 ? "not-allowed" : "pointer",
                    opacity: capturedImages.length >= 1 ? 0.5 : 1,
                  }}
                ></i>
              </div>
            )}
          </div>
          {showCamera && (
            <div>
              <Webcam
                audio={false}
                ref={webcamRef}
                height={280}
                screenshotFormat="image/jpeg"
                width={290}
                videoConstraints={videoConstraints}
              />
              <div
                className="d-flex flex-wrap gap-3"
                style={{ justifyContent: "center" }}
              >
                <i
                  className="fa-solid fa-camera fa-xl"
                  onClick={capturePhoto}
                  disabled={capturedImages.length >= 1}
                  style={{ cursor: "pointer" }}
                  title="Capture Photo"
                ></i>
                <i
                  className="fa-solid fa-camera-rotate fa-xl"
                  onClick={switchCamera}
                  style={{ cursor: "pointer" }}
                  title="Switch Camera"
                ></i>
                <i
                  className="fa-solid fa-xmark fa-xl"
                  onClick={closeCamera}
                  style={{ cursor: "pointer" }}
                  title="Close Camera"
                ></i>
              </div>
            </div>
          )}
          {capturedImages.length > 0 && (
            <div style={{ marginTop: "20px" }}>
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                {capturedImages.map((img, index) => (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "200px",
                      border: "2px solid #000",
                    }}
                  >
                    <img
                      src={
                        img?.includes("data:image")
                          ? img
                          : ImageProxyBaseUrl + encodeURIComponent(img)
                      }
                      alt={`Captured ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />

                    <i
                      className="fa-solid fa-xmark"
                      onClick={() => removeImage(index)}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        backgroundColor: "transparent",
                        color: "black",
                        border: "none",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                      }}
                    ></i>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="row mt-5">
            <div>
              <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => handleCancel()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={savedImages?.length === 0 || isLoading}
                  onClick={() => savePropertyImage()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploadPropertyImage;
